import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useConditionalityChartsDataContext } from './hooks/useConditionalityChartsDataContext';

export const ProfileCadUnicoComparisonPercentageAnual = () => {
    const { chartData } = useConditionalityChartsDataContext();

    return (
        <SimpleBars
            title={'Comparação de Perfil CAD Unico - Percentual (Anual)'}
            horizontal={false}
            subtitles={chartData?.profileCadUnicoComparisonPercentageAnual?.map((item) => getYearLabel(item.ano))}
            values={chartData?.profileCadUnicoComparisonPercentageAnual?.map((item) => item.percentage || 0)}
        />
    );
};
